var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0794 35.4838C46.9416 32.0728 48 28.16 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C28.2446 48 32.2318 46.8981 35.6913 44.9648C32.5319 44.6936 29.1394 42.7638 25.5941 39.2185L15.7802 29.4046C12.7503 26.3753 10.891 23.4408 10.2529 20.6832C9.48812 17.3743 10.4578 14.3384 13.1367 11.6602L14.8305 9.96704C15.4525 9.34571 16.2801 9.00267 17.1597 9.00267C17.6936 9.00267 18.2262 9.13481 18.6987 9.38508C21.2307 10.7245 23.979 15.3789 24.0945 15.5764C24.5843 16.4353 24.7372 17.3169 24.5296 18.0664C24.3734 18.6297 24.0171 19.0888 23.4978 19.3978C22.6836 20.0792 21.7319 20.9241 21.5824 21.1304C20.514 22.7074 20.6394 23.9641 22.0042 25.3289L29.6698 32.9951C31.0433 34.3686 32.2846 34.4907 33.8703 33.4149C34.0752 33.2674 34.9194 32.3157 35.6002 31.5015C36.0306 30.7781 36.7414 30.3803 37.6097 30.3803C38.1936 30.3803 38.8176 30.5605 39.4156 30.9009C39.5985 31.0081 43.3287 33.2098 45.0794 35.4838Z",
    fill: "#F0998D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1456f064462e0974a3a0c6e55cf20522.svg";
export { ForwardRef as ReactComponent };